export default "__VITE_ASSET__B1qtCn3j__"